/**
 * Чаcтота посещений
 * @return Promise
 */
const statVisitsList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/visits/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Чаcтота посещений. Кол-во строк.
 * @return Promise
 */
const statVisitsListCnt = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/visits/getListCnt",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Чаcтота посещений. Данные для графика
 * @return Promise
 */
const statVisitsChartData = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/visits/getChartData",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { statVisitsList, statVisitsListCnt, statVisitsChartData };
